export default __webpack_public_path__ + "static/media/2024-Annual-PREA-Report.ce949a3f.pdf";